@use "theme/typographyV2.scss" as typography;
@use "theme/breakpoints.scss";
@use "~components/LegacyCard/tokens.scss" as Card;
@use "~components/DescriptiveCheckbox/tokens.scss" as DescriptiveCheckbox;

@mixin page-gutter {
  margin-left: 20px;
  margin-right: 20px;
}

.backToHome {
  display: none;
  order: 2;
  flex-grow: 0;
  padding: 0 32px;

  &:hover:not(.buttonLoading) {
    border-color: var(--blue-01);
  }

  @include breakpoints.desktop {
    display: block;
    align-self: center;
    margin-left: auto;
  }
}

.backToHomeCustom {
  display: none;
  order: 2;
  flex-grow: 0;
  padding: 0 32px;
  border-radius: 20px;

  &:hover:not(.buttonLoading) {
    border-color: var(--blue-01);
  }

  @include breakpoints.desktop {
    display: block;
    align-self: center;
    margin-left: auto;
  }
}
.container {
  max-width: 684px;
}

.title {
  @include page-gutter;
  margin-top: 32px;
  color: var(--brand-indigo);
  font-family: typography.$font-serif;
  font-weight: 400;
  font-style: normal;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  font-size: 28px;

  @include breakpoints.desktop {
    font-size: 32px;
  }
}

.body {
  @include page-gutter;
  margin-bottom: 28px;
  font-family: typography.$font-mont;
  font-weight: 400;
  font-style: normal;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
}

.content {
  margin: 0 16px;
  padding: 16px 0;
}

.section {
  margin: 0;
  padding: 0 0 12px;
}

.sectionHeader {
  color: var(--blue-01);
  border-radius: 4px;
  min-height: 36px;
  background-color: var(--blue-03);
}

.preference {
  padding: 8px 0 16px;
  border-bottom: 1px solid var(--blue-01-at-30);

  &:last-child {
    border-bottom: none;
  }
}

.sectionTitle {
  @include typography.body-semibold;
  display: inline-block;
  margin: 0;
  padding: 8px 0;
  margin-left: 10px;
  text-align: center;
}

.cta {
  margin-top: 20px;
  width: 100%;
}

.footer {
  @include page-gutter;
  margin-top: 32px;
}

@mixin footer-gutter {
  margin-left: 16px;
  margin-right: 16px;
}

.footerText {
  @include footer-gutter;
  margin-top: 0;
  margin-bottom: 8px;
  font-family: typography.$font-mont;
  font-weight: 400;
  font-style: normal;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
}

.unsubscribe {
  @include footer-gutter;
}

.myAccount {
  justify-content: space-between;
}

.messageSuccess {
  font-family: typography.$font-mont;
}

.messageError {
  font-family: typography.$font-mont;
}
